import { render } from "./ProcessBpmPhoneConfirm.vue?vue&type=template&id=08faaf50&scoped=true"
import script from "./ProcessBpmPhoneConfirm.vue?vue&type=script&lang=js"
export * from "./ProcessBpmPhoneConfirm.vue?vue&type=script&lang=js"

import "./ProcessBpmPhoneConfirm.vue?vue&type=style&index=0&id=08faaf50&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08faaf50"]])

export default __exports__